// Runtime-agnostic confidence thresholds shared by client and server.
export const GRADING_THRESHOLDS = {
  LOW_CONFIDENCE: 0.7,
  MEDIUM_CONFIDENCE: 0.85,
} as const;

export const SPLIT_THRESHOLDS = {
  LOW_CONFIDENCE: 0.7,
  HIGH_CONFIDENCE: 0.85,
} as const;

export const STRUCTURE_EDITOR_BBX_THRESHOLDS = {
  LOW_CONFIDENCE: 0.7,
  HIGH_CONFIDENCE: 0.85,
} as const;

export const GRADING_CANVAS_WIDE_MIN_WIDTH = 750; // Minimum width for grading canvas to switch to wide layout (move image left)

export const MS_GS_CANVAS_WIDE_MIN_WIDTH = 750; // Minimum width for MS-GS canvas to switch to wide layout (move image left)

export const STRUCTURE_READONLY_ON_CONFIRM = true; // as we dont know if we can handle changes after confirmation without breaking something,
export const SUBMISSION_READONLY_ON_CONFIRM = true; // we set the structure editor and submission editor to read-only after confirmation

// LLM image-payload limits. OpenRouter caps request bodies at ~30 MB; we leave 1 MB of headroom.
// When the union of base64 images for a single LLM request exceeds the safe limit, agents fall
// back to resizing every image (max long edge LLM_IMAGE_MAX_PX, JPEG quality LLM_IMAGE_JPEG_QUALITY).
export const LLM_PAYLOAD_SAFE_LIMIT_BYTES = 29 * 1024 * 1024;
export const LLM_IMAGE_MAX_PX = 1500;
export const LLM_IMAGE_JPEG_QUALITY = 90;

// if the pdf file gets very big (Lyneham primary school, 360 pages), we dont hit token limit but the model still struggles to keep attention on all students
// often last few students are not handled and just combined to one => use Pro model for very big files and otherwise flash model which is faster and cheaper.
export const FLASH_PAGE_LIMIT = 200; // limit of pages for using flash model, above this we use pro model which is more expensive but can handle bigger files better.

// Regrade cutoffs for language and content. If the number of overall changes in a regrade request is below these thresholds, the regrade will be rejected.
// overall changes are counted in pendingLanguageUseWordDelta and pendingContentWordDelta @submission.ts
export const languageUseRegradeWordCutoff = 5;
export const contentRegradeWordCutoff = 0;

// Query parameter the Google OAuth callback sets when a SIGN-IN used an address that has no account: the callback then
// creates nothing and the client opens the sign-up with a notice. Set in server/utils/oauth-redirect.ts, read and
// removed in client/lib/oauth-no-account.ts. Lives here because the client bundle stubs everything under src/server.
export const OAUTH_NO_ACCOUNT_PARAM = 'oauthNoAccount';
